// extracted by mini-css-extract-plugin
export default {"searchControls":"SongsSearchControls_searchControls__xDsbk","isActiveOnMobile":"SongsSearchControls_isActiveOnMobile__DvBoB"};